import type { ComponentProps, ReactNode } from 'react';

import { Card } from '@zillow/constellation-10';

import { css } from '@/styled-system/css';

import { tileLinkStyles } from './styles';

type AccessibleCardLinkProps = {
  href: string;
  ariaLabel: string;
  testId: string;
  children: ReactNode;
  target?: string;
  rel?: string;
  rootCss?: ComponentProps<typeof Card.Root>['css'];
  onClick?: () => void;
};

// Card.BlockAnchor is tabIndex={-1} + aria-hidden, and Card.Root only wires role/tabIndex when given a
// handler, so the card itself becomes the anchor to keep it keyboard- and screen-reader-reachable.
const AccessibleCardLink = ({
  href,
  ariaLabel,
  testId,
  children,
  target,
  rel,
  rootCss,
  onClick,
}: AccessibleCardLinkProps) => (
  <Card.Root asChild interactive elevated={false} css={rootCss}>
    <a
      href={href}
      target={target}
      rel={rel}
      aria-label={ariaLabel}
      data-testid={testId}
      className={css(tileLinkStyles)}
      onClick={onClick}
    >
      {children}
    </a>
  </Card.Root>
);

export default AccessibleCardLink;
